var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-page" }, [
    _c(
      "div",
      {
        staticClass:
          "back-button body-base color-link font-bold hov-underline flex-shrink-0 w-100 cursor-pointer",
        on: {
          click: function($event) {
            return _vm.goBack()
          }
        }
      },
      [_vm._v("< BACK")]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "curated-boxes-page" },
      [
        !_vm.isMobile
          ? _c("div", { staticClass: "curated-boxes-images-container" }, [
              _c("div", { staticClass: "images-container" }, [
                _c("img", {
                  staticClass: "main-image",
                  attrs: { src: _vm.currentImage }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "extra-images-container" },
                  [
                    _c(
                      "Flicking",
                      {
                        ref: "flicking",
                        attrs: {
                          options: {
                            align: "prev",
                            circular: true,
                            preventDefaultOnDrag: true,
                            preventClickOnDrag: true,
                            renderOnlyVisible: true,
                            horizontal: false
                          }
                        }
                      },
                      [
                        _vm._l(_vm.curatedBoxImages, function(image) {
                          return [
                            _c("img", {
                              staticClass: "extra-image",
                              class:
                                image.src == _vm.currentImage ? "selected" : "",
                              attrs: { src: image.src, loading: "lazy" },
                              on: {
                                click: function($event) {
                                  return _vm.selectImage(image.src)
                                }
                              }
                            })
                          ]
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              !_vm.isMobile
                ? _c("div", { staticClass: "product-legend" }, [
                    _c("p", { staticClass: "title" }, [
                      _vm._v(
                        "Ship exactly how you need. In checkout, you'll be able to:"
                      )
                    ]),
                    _vm._v(" "),
                    _vm._m(0),
                    _vm._v(" "),
                    _vm._m(1),
                    _vm._v(" "),
                    _vm._m(2)
                  ])
                : _vm._e()
            ])
          : _vm.curatedBoxImages.length > 0
          ? _c(
              "VueSlickCarousel",
              {
                attrs: {
                  infinite: true,
                  dots: true,
                  arrows: false,
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              },
              _vm._l(_vm.curatedBoxImages, function(image) {
                return _c(
                  "div",
                  {
                    key: image.src,
                    staticClass: "curated-boxes-images-container"
                  },
                  [
                    _c("img", {
                      staticClass: "main-image",
                      attrs: { src: image.src }
                    })
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "curated-boxes-main-container" }, [
          _c("p", { staticClass: "main-title" }, [
            _vm._v(_vm._s(_vm.curatedBoxTitle))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "qty-wrapper" }, [
            _c("div", { staticClass: "box-qty-container" }, [
              _c("div", { staticClass: "input-container" }, [
                _c(
                  "div",
                  {
                    staticClass: "box-qty-input-container",
                    class: _vm.canAddMore ? "" : "no-more"
                  },
                  [
                    _c(
                      "button",
                      {
                        attrs: { disabled: _vm.selectedBoxQty < _vm.minQty },
                        on: {
                          click: function($event) {
                            return _vm.incrementBoxQty(false)
                          }
                        }
                      },
                      [_vm._v("-")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedBoxQty,
                          expression: "selectedBoxQty"
                        }
                      ],
                      attrs: { disabled: true, type: "number", min: "1" },
                      domProps: { value: _vm.selectedBoxQty },
                      on: {
                        blur: function($event) {
                          return _vm.changeBoxQty(null)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.selectedBoxQty = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: {
                              content: "Not enough inventory",
                              container: false
                            },
                            expression:
                              "{content: 'Not enough inventory', container:false}"
                          }
                        ],
                        on: {
                          click: function($event) {
                            return _vm.incrementBoxQty(true)
                          }
                        }
                      },
                      [_vm._v("+")]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.minQty > 1
                  ? _c("p", { staticClass: "min-alert" }, [
                      _vm._v("Minimum: " + _vm._s(_vm.minQty))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "price-container" }, [
                _c("p", { staticClass: "price" }, [
                  _vm._v(_vm._s(_vm.currentPrice))
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.selectedBoxQty > 1 && !_vm.paidCard
              ? _c(
                  "div",
                  { staticClass: "blank-card-container desktop-flex" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.hasMultipleCards,
                          expression: "hasMultipleCards"
                        }
                      ],
                      attrs: { id: "multipleCards", type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.hasMultipleCards)
                          ? _vm._i(_vm.hasMultipleCards, null) > -1
                          : _vm.hasMultipleCards
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$a = _vm.hasMultipleCards,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.hasMultipleCards = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.hasMultipleCards = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.hasMultipleCards = $$c
                            }
                          },
                          _vm.changeMultipleCards
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "multipleCards" } }, [
                      _vm._v("I want multiple cards!")
                    ])
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc-title" }, [_vm._v("Description")]),
          _vm._v(" "),
          _c("p", {
            staticClass: "product-desc",
            class: _vm.descExpanded ? "expanded" : "",
            domProps: { innerHTML: _vm._s(_vm.description) }
          }),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "purple-expand mobile",
              on: {
                click: function() {
                  _vm.descExpanded = !_vm.descExpanded
                }
              }
            },
            [_vm._v("Show " + _vm._s(_vm.descExpanded ? "less" : "more"))]
          ),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "qty-wrapper" }, [
            _vm.selectedBoxQty > 1 && !_vm.paidCard
              ? _c("div", { staticClass: "blank-card-container" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.hasMultipleCards,
                        expression: "hasMultipleCards"
                      }
                    ],
                    attrs: { id: "multipleCards", type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.hasMultipleCards)
                        ? _vm._i(_vm.hasMultipleCards, null) > -1
                        : _vm.hasMultipleCards
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = _vm.hasMultipleCards,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.hasMultipleCards = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.hasMultipleCards = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.hasMultipleCards = $$c
                          }
                        },
                        _vm.changeMultipleCards
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "multipleCards" } }, [
                    _vm._v("I want multiple cards!")
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          !_vm.noCard && !_vm.paidCard && !_vm.hasMultipleCards
            ? _c(
                "div",
                {
                  staticClass: "write-container",
                  attrs: { id: "write-container" }
                },
                [
                  _c("div", { staticClass: "pick-card-container" }, [
                    _c("div", { staticClass: "pick-card-header" }, [
                      _c("p", { staticClass: "title" }, [
                        _vm._v("Pick Your Card")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "arrows-container" }, [
                        _c("img", {
                          staticClass: "l-arrow",
                          attrs: {
                            src:
                              "https://cdn.shopify.com/s/files/1/1363/8433/files/white_button_square.svg?v=1720472546",
                            alt: "left arrow"
                          },
                          on: {
                            click: function($event) {
                              return _vm.$refs.featured.prev()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "r-arrow",
                          attrs: {
                            src:
                              "https://cdn.shopify.com/s/files/1/1363/8433/files/white_button_square.svg?v=1720472546",
                            alt: "right arrow"
                          },
                          on: {
                            click: function($event) {
                              return _vm.$refs.featured.next()
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "blank-card-container" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.isNoCard,
                              expression: "isNoCard"
                            }
                          ],
                          attrs: { id: "noCard", type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.isNoCard)
                              ? _vm._i(_vm.isNoCard, null) > -1
                              : _vm.isNoCard
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.isNoCard,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.isNoCard = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.isNoCard = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.isNoCard = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "noCard" } }, [
                          _vm._v("Skip your Card")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.showCardAlert
                      ? _c("p", { staticClass: "red-alert" }, [
                          _vm._v("Please select a card")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isNoCard && _vm.cardProducts.length > 0
                      ? _c(
                          "div",
                          { staticClass: "cards-container" },
                          [
                            _c(
                              "Flicking",
                              {
                                ref: "featured",
                                staticClass: "flicking-goc-collection",
                                attrs: {
                                  plugins: _vm.plugins1,
                                  options: {
                                    align: "prev",
                                    circular: true,
                                    preventDefaultOnDrag: true,
                                    preventClickOnDrag: true,
                                    panelsPerView: 5
                                  }
                                }
                              },
                              _vm._l(_vm.sortedCards, function(card) {
                                return _c(
                                  "div",
                                  {
                                    key: card.id,
                                    staticClass: "card-container",
                                    class:
                                      _vm.selectedCard.id == card.id
                                        ? "selected"
                                        : "",
                                    on: {
                                      click: function($event) {
                                        return _vm.selectCard(card)
                                      }
                                    }
                                  },
                                  [
                                    _vm.selectedCard.id == card.id
                                      ? _c("img", {
                                          staticClass: "green-check",
                                          attrs: {
                                            src:
                                              "https://cdn.shopify.com/s/files/1/1363/8433/files/check-circle.svg?v=1658433688"
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("img", {
                                      staticClass: "main-image",
                                      attrs: {
                                        src: _vm._f("getProductImage")(card)
                                      }
                                    })
                                  ]
                                )
                              }),
                              0
                            )
                          ],
                          1
                        )
                      : !_vm.isNoCard && _vm.cardProducts.length == 0
                      ? _c(
                          "ul",
                          { staticClass: "cards-container no-scrollbar" },
                          _vm._l(12, function(n) {
                            return _c(
                              "li",
                              { key: n, staticClass: "card-container" },
                              [_c("CardSkeleton")],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  !_vm.isNoCard
                    ? _c("div", { staticClass: "write-header" }, [
                        _c("p", { staticClass: "title" }, [
                          _vm._v("Write Your Note")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "blank-card-container" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.isEmptyMessage,
                                expression: "isEmptyMessage"
                              }
                            ],
                            attrs: { id: "blankCard", type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.isEmptyMessage)
                                ? _vm._i(_vm.isEmptyMessage, null) > -1
                                : _vm.isEmptyMessage
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.isEmptyMessage,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.isEmptyMessage = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.isEmptyMessage = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.isEmptyMessage = $$c
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "blankCard" } }, [
                            _vm._v("Leave the card blank")
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isNoCard && !_vm.isEmptyMessage
                    ? _c("div", { staticClass: "form-container" }, [
                        _c("p", { staticClass: "purple-span" }, [
                          _vm._v(
                            "Type in your message below. A real human will hand write your message and include it in your gift."
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "message-container" }, [
                          _vm.showAlert
                            ? _c("p", { staticClass: "red-alert" }, [
                                _vm._v("Please type your message below")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "message" } }, [
                            _vm._v("Your Message:")
                          ]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.message.text,
                                expression: "message.text"
                              }
                            ],
                            attrs: {
                              disabled: _vm.isEmptyMessage,
                              placeholder: "Start typing here...",
                              maxlength: "200",
                              cols: "30",
                              rows: "3",
                              id: "message"
                            },
                            domProps: { value: _vm.message.text },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.message,
                                  "text",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "from-container" }, [
                          _vm.showAlert
                            ? _c("p", { staticClass: "red-alert" }, [
                                _vm._v("Please type your message below")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "from" } }, [
                            _vm._v("From:")
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.message.from,
                                expression: "message.from"
                              }
                            ],
                            attrs: {
                              disabled: _vm.isEmptyMessage,
                              placeholder: "Your Name",
                              maxlength: "200",
                              id: "from",
                              type: "text"
                            },
                            domProps: { value: _vm.message.from },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.message,
                                  "from",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "purple-span",
                              class: _vm.remainingCharacters < 0 ? "red" : ""
                            },
                            [
                              _vm._v(
                                "Character Remaining " +
                                  _vm._s(_vm.remainingCharacters)
                              )
                            ]
                          )
                        ])
                      ])
                    : _vm._e()
                ]
              )
            : !_vm.noCard && !_vm.paidCard && _vm.hasMultipleCards
            ? _c("div", { staticClass: "addresses-container" }, [
                _vm._m(4),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "multiple-addresses-container" },
                  _vm._l(_vm.addresses, function(address, i) {
                    return _c(
                      "div",
                      {
                        key: address.id,
                        staticClass: "address-container",
                        class: [i % 2 == 0 ? "odd" : "even"]
                      },
                      [
                        _vm._m(5, true),
                        _vm._v(" "),
                        _c("div", { staticClass: "selectors-container" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.addresses[i].qty,
                                  expression: "addresses[i].qty"
                                }
                              ],
                              staticClass: "address-qty-selector",
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.addresses[i],
                                      "qty",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  _vm.checkSelectedQty
                                ]
                              }
                            },
                            _vm._l(_vm.maxQtyPerAddress(address), function(
                              qty
                            ) {
                              return _c(
                                "option",
                                { key: qty, domProps: { value: qty } },
                                [_vm._v(_vm._s(qty))]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "happybox-button border",
                              class:
                                address.card &&
                                (address.isEmpty || address.message.length > 0)
                                  ? "green"
                                  : "white",
                              on: {
                                click: function($event) {
                                  return _vm.selectAddress(i)
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  address.card &&
                                    (address.isEmpty ||
                                      address.message.length > 0)
                                    ? "Selected!"
                                    : "Select your card"
                                )
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.addresses.length > 1
                          ? _c("img", {
                              staticClass: "remove lazyload",
                              attrs: {
                                src:
                                  "https://cdn.shopify.com/s/files/1/1363/8433/files/x_1.svg?v=1732737242"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.popAddress(i)
                                }
                              }
                            })
                          : _vm._e()
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "add-address",
                    class: _vm.canAddMoreAddresses ? "" : "disabled",
                    on: {
                      click: function($event) {
                        return _vm.addNewAddress()
                      }
                    }
                  },
                  [_vm._v("+ Add new address")]
                )
              ])
            : !_vm.noCard && _vm.paidCard
            ? _c(
                "div",
                {
                  staticClass: "write-container",
                  attrs: { id: "write-container" }
                },
                [
                  _c("div", { staticClass: "pick-card-container" }, [
                    _c("div", { staticClass: "paid-card-header" }, [
                      _c("div", { staticClass: "selection-container" }, [
                        _c("p", { staticClass: "title" }, [
                          _vm._v("Add a handwritten card for $6")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "blank-card-container" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedPaidCard,
                                expression: "selectedPaidCard"
                              }
                            ],
                            attrs: { id: "blankCard", type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.selectedPaidCard)
                                ? _vm._i(_vm.selectedPaidCard, null) > -1
                                : _vm.selectedPaidCard
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.selectedPaidCard,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectedPaidCard = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectedPaidCard = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectedPaidCard = $$c
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "blankCard" } }, [
                            _vm._v("I want a card")
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "subtitle" }, [
                        _vm._v(
                          "\n                            Include a card with each gift. Our team will handwrite your message for you and ship along with the item you choose, directly to your recipient\n                        "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.showCardAlert
                      ? _c("p", { staticClass: "red-alert" }, [
                          _vm._v("Please select a card")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedPaidCard && _vm.sortedCards.length > 0
                      ? _c(
                          "div",
                          { staticClass: "cards-container" },
                          _vm._l(_vm.sortedCards, function(card) {
                            return _c(
                              "div",
                              {
                                key: card.id,
                                staticClass: "card-container",
                                class:
                                  _vm.selectedCard.id == card.id
                                    ? "selected"
                                    : "",
                                on: {
                                  click: function($event) {
                                    return _vm.selectCard(card)
                                  }
                                }
                              },
                              [
                                _vm.selectedCard.id == card.id
                                  ? _c("img", {
                                      staticClass: "green-check",
                                      attrs: {
                                        src:
                                          "https://cdn.shopify.com/s/files/1/1363/8433/files/check-circle.svg?v=1658433688"
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("img", {
                                  staticClass: "main-image",
                                  attrs: {
                                    src: _vm._f("getProductImage")(card)
                                  }
                                })
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.selectedPaidCard
                    ? _c("div", { staticClass: "write-header" }, [
                        _c("p", { staticClass: "title" }, [
                          _vm._v("Write Your Note")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedPaidCard
                    ? _c("div", { staticClass: "form-container" }, [
                        _c("p", { staticClass: "purple-span" }, [
                          _vm._v(
                            "Type in your message below. A real human will hand write your message and include it in your gift."
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "message-container" }, [
                          _vm.showAlert
                            ? _c("p", { staticClass: "red-alert" }, [
                                _vm._v("Please type your message below")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "message" } }, [
                            _vm._v("Your Message:")
                          ]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.message.text,
                                expression: "message.text"
                              }
                            ],
                            attrs: {
                              disabled: !_vm.selectedPaidCard,
                              placeholder: "Start typing here...",
                              maxlength: "200",
                              cols: "30",
                              rows: "3",
                              id: "message"
                            },
                            domProps: { value: _vm.message.text },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.message,
                                  "text",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "from-container" }, [
                          _vm.showAlert
                            ? _c("p", { staticClass: "red-alert" }, [
                                _vm._v("Please type your message below")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "from" } }, [
                            _vm._v("From:")
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.message.from,
                                expression: "message.from"
                              }
                            ],
                            attrs: {
                              disabled: !_vm.selectedPaidCard,
                              placeholder: "Your Name",
                              maxlength: "200",
                              id: "from",
                              type: "text"
                            },
                            domProps: { value: _vm.message.from },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.message,
                                  "from",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "purple-span",
                              class: _vm.remainingCharacters < 0 ? "red" : ""
                            },
                            [
                              _vm._v(
                                "Character Remaining " +
                                  _vm._s(_vm.remainingCharacters)
                              )
                            ]
                          )
                        ])
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "end-buttons-container" }, [
            _c(
              "button",
              {
                staticClass: "hb-btn primary w-100",
                on: {
                  click: function($event) {
                    return _vm.addToCart(false)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.addBtnTxt))]
            ),
            _vm._v(" "),
            _vm.isPreorder
              ? _c("p", { staticClass: "preorder-alert" }, [
                  _vm._v("Ships in time for mid December delivery")
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.isMobile
              ? _c("div", { staticClass: "ad" }, [
                  _c("img", {
                    attrs: {
                      src:
                        "https://cdn.shopify.com/s/files/1/1363/8433/files/build_a_custom_gift_box_2.png?v=1724873739"
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(6)
                ])
              : _vm._e()
          ])
        ])
      ],
      1
    ),
    _vm._v(" "),
    _vm.isMobile
      ? _c("div", { staticClass: "product-legend" }, [
          _c("p", { staticClass: "title" }, [
            _vm._v("Ship exactly how you need. In checkout, you'll be able to:")
          ]),
          _vm._v(" "),
          _vm._m(7),
          _vm._v(" "),
          _vm._m(8),
          _vm._v(" "),
          _vm._m(9)
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isMobile
      ? _c("div", { staticClass: "ad" }, [
          _c("img", {
            attrs: {
              src:
                "https://cdn.shopify.com/s/files/1/1363/8433/files/build_a_custom_gift_box_2.png?v=1724873739"
            }
          }),
          _vm._v(" "),
          _vm._m(10)
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.noCard && _vm.recoProducts.length > 0
      ? _c(
          "div",
          { staticClass: "more-gifts" },
          [
            _c("p", { staticClass: "main-title" }, [_vm._v("Best Sellers")]),
            _vm._v(" "),
            !_vm.isMobile
              ? _c(
                  "div",
                  { staticClass: "products-container" },
                  _vm._l(_vm.recoProducts, function(product) {
                    return _c(
                      "div",
                      {
                        key: product.id,
                        staticClass: "product-container",
                        on: {
                          click: function($event) {
                            return _vm.selectNewProduct(product)
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: { src: _vm._f("getProductImage")(product) }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "curated-footer" }, [
                          _c("div", { staticClass: "curated-desc" }, [
                            _c("p", { staticClass: "title" }, [
                              _vm._v(_vm._s(product.title))
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "price" }, [
                              _vm._v(_vm._s(_vm._f("moneyFormat")(product)))
                            ])
                          ])
                        ])
                      ]
                    )
                  }),
                  0
                )
              : _vm.recoProducts.length > 0
              ? _c(
                  "VueSlickCarousel",
                  {
                    attrs: {
                      infinite: true,
                      dots: true,
                      arrows: false,
                      slidesToShow: 2,
                      slidesToScroll: 1
                    }
                  },
                  _vm._l(_vm.recoProducts, function(product) {
                    return _c(
                      "div",
                      {
                        key: product.id,
                        staticClass: "product-container",
                        on: {
                          click: function($event) {
                            return _vm.selectNewProduct(product)
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: { src: _vm._f("getProductImage")(product) }
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "happybox-button white border",
                            on: {
                              click: function($event) {
                                return _vm.selectProduct(product)
                              }
                            }
                          },
                          [_vm._v("View Box")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "curated-footer" }, [
                          _c("div", { staticClass: "curated-desc" }, [
                            _c("p", { staticClass: "title" }, [
                              _vm._v(_vm._s(product.title))
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "price" }, [
                              _vm._v(_vm._s(_vm._f("moneyFormat")(product)))
                            ])
                          ])
                        ])
                      ]
                    )
                  }),
                  0
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.selectedAddress !== null && _vm.showCardModal !== false
      ? _c(
          "div",
          {
            staticClass: "modal-wrapper",
            on: { click: _vm.closeAddressModal }
          },
          [
            _c(
              "div",
              {
                staticClass: "modal-container",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "x",
                  attrs: {
                    src:
                      "https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652",
                    alt: "x"
                  },
                  on: { click: _vm.closeAddressModal }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "write-container" }, [
                  _c("div", { staticClass: "pick-card-container" }, [
                    _c("div", { staticClass: "pick-card-header" }, [
                      _c("p", { staticClass: "title" }, [
                        _vm._v("Pick Your Card")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "arrows-container" }, [
                        _c("img", {
                          staticClass: "l-arrow",
                          attrs: {
                            src:
                              "https://cdn.shopify.com/s/files/1/1363/8433/files/white_button_square.svg?v=1720472546",
                            alt: "left arrow"
                          },
                          on: {
                            click: function($event) {
                              return _vm.$refs.cards.prev()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "r-arrow",
                          attrs: {
                            src:
                              "https://cdn.shopify.com/s/files/1/1363/8433/files/white_button_square.svg?v=1720472546",
                            alt: "right arrow"
                          },
                          on: {
                            click: function($event) {
                              return _vm.$refs.cards.next()
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.showCardAlert
                      ? _c("p", { staticClass: "red-alert" }, [
                          _vm._v("Please select a card")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.cardProducts.length > 0
                      ? _c(
                          "div",
                          { staticClass: "cards-container" },
                          [
                            _c(
                              "Flicking",
                              {
                                ref: "cards",
                                staticClass: "flicking-goc-collection",
                                attrs: {
                                  plugins: _vm.plugins2,
                                  options: {
                                    align: "prev",
                                    circular: true,
                                    preventDefaultOnDrag: true,
                                    preventClickOnDrag: true,
                                    panelsPerView: 5
                                  }
                                }
                              },
                              _vm._l(_vm.sortedCards, function(card) {
                                return _c(
                                  "div",
                                  {
                                    key: card.id,
                                    staticClass: "card-container",
                                    class:
                                      _vm.addresses[_vm.selectedAddress].card ==
                                      card.title
                                        ? "selected"
                                        : "",
                                    on: {
                                      click: function($event) {
                                        return _vm.selectAddressCard(card)
                                      }
                                    }
                                  },
                                  [
                                    _vm.addresses[_vm.selectedAddress].card ==
                                    card.title
                                      ? _c("img", {
                                          staticClass: "green-check",
                                          attrs: {
                                            src:
                                              "https://cdn.shopify.com/s/files/1/1363/8433/files/check-circle.svg?v=1658433688"
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("img", {
                                      staticClass: "main-image",
                                      attrs: {
                                        src: _vm._f("getProductImage")(card)
                                      }
                                    })
                                  ]
                                )
                              }),
                              0
                            )
                          ],
                          1
                        )
                      : _vm.cardProducts.length == 0
                      ? _c(
                          "ul",
                          { staticClass: "cards-container no-scrollbar" },
                          _vm._l(12, function(n) {
                            return _c(
                              "li",
                              { key: n, staticClass: "card-container" },
                              [_c("CardSkeleton")],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "write-header" }, [
                    _c("p", { staticClass: "title" }, [
                      _vm._v("Write Your Note")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "blank-card-container" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.addresses[_vm.selectedAddress].isEmpty,
                            expression: "addresses[selectedAddress].isEmpty"
                          }
                        ],
                        attrs: { id: "blankCard", type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(
                            _vm.addresses[_vm.selectedAddress].isEmpty
                          )
                            ? _vm._i(
                                _vm.addresses[_vm.selectedAddress].isEmpty,
                                null
                              ) > -1
                            : _vm.addresses[_vm.selectedAddress].isEmpty
                        },
                        on: {
                          change: function($event) {
                            var $$a =
                                _vm.addresses[_vm.selectedAddress].isEmpty,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.addresses[_vm.selectedAddress],
                                    "isEmpty",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.addresses[_vm.selectedAddress],
                                    "isEmpty",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.addresses[_vm.selectedAddress],
                                "isEmpty",
                                $$c
                              )
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "blankCard" } }, [
                        _vm._v("Leave the card blank")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  !_vm.addresses[_vm.selectedAddress].isEmpty
                    ? _c("div", { staticClass: "form-container" }, [
                        _c("p", { staticClass: "purple-span" }, [
                          _vm._v(
                            "Type in your message below. A real human will hand write your message and include it in your gift."
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "message-container" }, [
                          _vm.showAlert
                            ? _c("p", { staticClass: "red-alert" }, [
                                _vm._v("Please type your message below")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "message" } }, [
                            _vm._v("Your Message:")
                          ]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.addresses[_vm.selectedAddress].message,
                                expression: "addresses[selectedAddress].message"
                              }
                            ],
                            attrs: {
                              placeholder: "Start typing here...",
                              maxlength: "200",
                              cols: "30",
                              rows: "3",
                              id: "message"
                            },
                            domProps: {
                              value: _vm.addresses[_vm.selectedAddress].message
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.addresses[_vm.selectedAddress],
                                  "message",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "from-container" }, [
                          _vm.showAlert
                            ? _c("p", { staticClass: "red-alert" }, [
                                _vm._v("Please type your message below")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "from" } }, [
                            _vm._v("From:")
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.addresses[_vm.selectedAddress].from,
                                expression: "addresses[selectedAddress].from"
                              }
                            ],
                            attrs: {
                              placeholder: "Your Name",
                              maxlength: "200",
                              id: "from",
                              type: "text"
                            },
                            domProps: {
                              value: _vm.addresses[_vm.selectedAddress].from
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.addresses[_vm.selectedAddress],
                                  "from",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "purple-span",
                              class:
                                _vm.remainingAddressCharacters < 0 ? "red" : ""
                            },
                            [
                              _vm._v(
                                "Character Remaining " +
                                  _vm._s(_vm.remainingAddressCharacters)
                              )
                            ]
                          )
                        ])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "actions-container" }, [
                  _c(
                    "button",
                    {
                      staticClass: "happybox-button green border",
                      on: {
                        click: function($event) {
                          return _vm.confirmCardAddress()
                        }
                      }
                    },
                    [_vm._v("Confirm")]
                  )
                ])
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "subcopy" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/ship_7cab1626-214e-4ea1-9ee3-da0e85c3e33c.svg?v=1724856350"
        }
      }),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "\n                        Bulk ship to one location, ship to many individual addresses, or a mix of both!\n                    "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "subcopy postcard" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/address_fd703cb6-c0b9-46dc-9547-e254a460054a.svg?v=1724856349"
        }
      }),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "\n                        Ship with just an email address. (no physical address needed)\n                    "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "subcopy box-wing" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/shipping_speed.svg?v=1724856349"
        }
      }),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "Select your shipping speed: rush or standard, international or domestic."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "branding-legend" }, [
      _vm._v("Need a higher quantity or want to add branding? Email "),
      _c("a", { attrs: { href: "mailto:corporate@happyboxstore.com" } }, [
        _vm._v("corporate@happyboxstore.com")
      ]),
      _vm._v(". Typical response time: 1 business day.")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "addresses-title" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/assitance.svg?v=1718205326",
          alt: "customize",
          width: "20px",
          height: "10px"
        }
      }),
      _vm._v(" Recipient List")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-container" }, [
      _c("p", [_vm._v("Gift Quantity")]),
      _vm._v(" "),
      _c("p", [_vm._v("Card")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-container" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Build a Custom Gift Box")]),
      _vm._v(" "),
      _c("p", { staticClass: "subtitle" }, [
        _vm._v("Shop hundreds of gifts to build 100% personalized gift box.")
      ]),
      _vm._v(" "),
      _c("a", { attrs: { href: "/products/build-a-box" } }, [
        _vm._v("Start Building >")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "subcopy" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/ship_7cab1626-214e-4ea1-9ee3-da0e85c3e33c.svg?v=1724856350"
        }
      }),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "\n                Bulk ship to one location, ship to many individual addresses, or a mix of both!\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "subcopy postcard" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/address_fd703cb6-c0b9-46dc-9547-e254a460054a.svg?v=1724856349"
        }
      }),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "\n                Ship with just an email address. (no physical address needed)\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "subcopy box-wing" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/shipping_speed.svg?v=1724856349"
        }
      }),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "Select your shipping speed: rush or standard, international or domestic."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-container" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Build a Custom Gift Box")]),
      _vm._v(" "),
      _c("p", { staticClass: "subtitle" }, [
        _vm._v("Shop hundreds of gifts to build 100% personalized gift box.")
      ]),
      _vm._v(" "),
      _c("a", { attrs: { href: "/products/build-a-box" } }, [
        _vm._v("Start Building >")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }